import { AxiosResponse } from 'axios';
import { BrandProduct } from './api.endpoints';
import ApiService from './api.service';
import { CoaQueryPayload, ProductCOAPayload } from '../write.types';

class ProductService extends ApiService {
  async createProduct(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandProduct.CREATE_PRODUCT, payload);
    return response;
  }

  async updateProduct(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandProduct.UPDATE_PRODUCT, payload);
    return response;
  }

  async deleteProduct(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandProduct.DELETE_PRODUCT, payload);
    return response;
  }

  async searchCoaByQuery(payload: CoaQueryPayload): Promise<AxiosResponse | undefined> {
    const response = await this.get(BrandProduct.SEARCH_PRODUCT_COA, payload);
    return response;
  }

  async fetchAllCoaByBrand(brandId: string): Promise<AxiosResponse | undefined> {
    const response = await this.get(BrandProduct.SEARCH_PRODUCT_COA_BY_BRAND, { brandId });
    return response;
  }

  async createProductCOA(payload: ProductCOAPayload): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandProduct.CREATE_PRODUCT_COA, payload);
    return response;
  }
}

export default ProductService;
